import { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import styles from './PaymentStatusPopup.module.css';
import { PaymentContext } from '../../../contexts/PaymentContext';
import { IconButton, Button } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { PAYMENT_STATUS, ROUTES } from '../../../const';

const PAYMENT_STATUS_CONFIG = {
    [PAYMENT_STATUS.SUCCESS]: {
        title: 'Payment Successful',
        subtitle: 'The payment has been completed successfully. Your order is confirmed.',
        action: 'VIEW_ORDER',
    },

    [PAYMENT_STATUS.FAILED]: {
        title: 'Payment Failed',
        subtitle: 'The payment could not be processed. Please try again or use a different payment method.',
    },

    [PAYMENT_STATUS.PENDING]: {
        title: 'Payment Pending',
        subtitle: 'The payment is currently being processed. Please wait or check the status shortly.',
        action: 'VIEW_PAYMENT_STATUS',
    },

    [PAYMENT_STATUS.REFUND_SUCCESS]: {
        title: 'Refund Successful',
        subtitle: 'The refund has been processed successfully. The amount will be credited as per bank timelines.',
    },

    [PAYMENT_STATUS.REFUND_FAILED]: {
        title: 'Refund Failed',
        subtitle: 'We were unable to process the refund. Please try again or contact support.',
    },
};

function PaymentStatusPopups() {
    const { paymentPopups, closePopup } = useContext(PaymentContext);
    const history = useHistory();

    const p = paymentPopups[paymentPopups.length - 1];

    if (!p) {
        return null;
    }

    const config = PAYMENT_STATUS_CONFIG[p.status];

    const handleViewOrderStatus = (payment) => {
        closePopup(payment);
        const url = ROUTES.PAYMENT_STATUS.replace(':shopId', payment?.shop_id);
        const query = `?message=Ok&payment_id=${payment?.payment_id}&secret=${payment?.payment_secret}`;
        history.push(url + query);
    };

    const handleViewOrderDetails = (payment) => {
        closePopup(payment);
        const url = ROUTES.ORDER_DETAILS
            .replace(':shopId', payment?.shop_id)
            .replace(':orderId', payment?.order_id);
        history.push(url);
    };

    return (
        <div className={styles.popupBackdrop}>
            <div className={styles.dialogContainer}>
                <div className={styles.dialogTitleDiv}>
                    <span className={styles.title}>{config?.title}</span>
                    <IconButton
                        size="small"
                        onClick={() => closePopup(p)}
                    >
                        <CloseIcon />
                    </IconButton>
                </div>
                <div className={styles.contentDiv}>
                    <span className={styles.message}>{config?.subtitle}</span>
                </div>
                <div className={styles.actionDiv}>
                    <Button variant="contained" onClick={() => closePopup(p)} className={styles.cancelBtn}>
                        Cancel
                    </Button>
                    {config?.action === 'VIEW_ORDER' && (
                        <Button variant="contained" onClick={() => handleViewOrderDetails(p)} className={styles.successBtn}>
                            Details
                        </Button>
                    )}
                    {config?.action === 'VIEW_PAYMENT_STATUS' && (
                        <Button variant="contained" onClick={() => handleViewOrderStatus(p)} className={styles.successBtn}>
                            Details
                        </Button>
                    )}
                </div>
            </div>
        </div>
    );
}

export default PaymentStatusPopups;

